import * as React from "react";
import { DataLayer } from "@grandvisionhq/analytics";
import { monetate } from "@grandvisionhq/svc-monetate";
import AppointmentConfirmationContainer from "../../../../../../../../../components/AppointmentConfirmation/v3/components/AppointmentConfirmation/AppointmentConfirmationContainer.js";
import { bookAppointmentConfirmationScreenEvent } from "../../../../../../../../../data-layer/v3/data-layer/actions.js";
import { useAppointmentContext } from "../../../../../../../context/v3/pages/BookAppointment/context/AppointmentContext.js";
import { useRoutingContext } from "../../../../../../../context/RoutingContext/v3/pages/BookAppointment/context/RoutingContext/context.js";
import { getBookAppointmentStore } from "../../../../../../../data/v3/pages/BookAppointment/data/book-appointment-store-by-id.js";
import { getBookAppointmentTryInStoreProducts } from "../../../../../../../data/v3/pages/BookAppointment/data/book-appointment-try-in-store-products.js";
import { getBookAppointmentType } from "../../../../../../../data/v3/pages/BookAppointment/data/book-appointment-type.js";
import { MissingStoreIdError, AlternativeUrlStoreError, MissingTypeIdError, MissingTimeSlotStartError, MissingTimeSlotEndError, MissingAppointmentIdError, InvalidVirtualAppointmentError, StoreNotFoundError, TypeNotFoundError, TypeNotAvailableForStoreError } from "../../../../../../../v3/pages/BookAppointment/errors.js";
import { getFormattedParams, hasValidVirtualAppointmentParams, generateVirtualAppointmentStoreByIdData, hasInvalidVirtualAppointmentParams, isAppointmentTypeValid } from "../../../../../../../v3/pages/BookAppointment/utils.js";
import useVirtualAppointment from "../../../../../../../hooks/v3/pages/BookAppointment/hooks/use-virtual-appointment.js";
const whereStep = "where";
const isClient = typeof window !== "undefined";
const ConfirmationRoot = () => {
  const [, { store, type, timeSlot, appointment }] = useAppointmentContext();
  const [{ isVirtualAppointmentType }] = useVirtualAppointment();
  const [{ goTo }] = useRoutingContext();
  React.useEffect(() => {
    if (store && type && timeSlot && appointment) {
      const dataLayerEvent = bookAppointmentConfirmationScreenEvent({
        store: !isVirtualAppointmentType(type) ? {
          code: store.code,
          // TODO: MACC-19077
          globalStoreId: store.globalStoreId,
          streetName: store.streetName,
          town: store.town,
          name: store.name,
          postalCode: store.postalCode,
          streetNumber: store.streetNumber,
          additionalStreetInfo: store.additionalStreetInfo
        } : void 0,
        appointment: {
          id: appointment?.id,
          appointmentType: {
            id: type.id,
            isVirtualAppointment: isVirtualAppointmentType(type),
            ageGroup: type.ageGroup
          },
          startTime: timeSlot?.from,
          endTime: timeSlot?.until
        }
      });
      DataLayer.pushEvent(dataLayerEvent);
      monetate().trackEvent("BookEyeExam");
    }
  }, []);
  if (isClient && !appointment) {
    goTo(whereStep, {});
    return null;
  }
  return /* @__PURE__ */ React.createElement(AppointmentConfirmationContainer, null);
};
ConfirmationRoot.getServerSideProps = async (apolloClient, params, locale) => {
  const formattedParams = getFormattedParams(params);
  if (formattedParams.globalStoreId === void 0) {
    throw MissingStoreIdError();
  }
  if (formattedParams.alternativeUrlStores?.includes(formattedParams.globalStoreId)) {
    throw AlternativeUrlStoreError();
  }
  if (formattedParams.typeId === void 0) {
    throw MissingTypeIdError();
  }
  if (formattedParams.start === void 0) {
    throw MissingTimeSlotStartError();
  }
  if (formattedParams.end === void 0) {
    throw MissingTimeSlotEndError();
  }
  if (formattedParams.appointmentId === void 0) {
    throw MissingAppointmentIdError();
  }
  let promises = [null, null, void 0];
  if (hasValidVirtualAppointmentParams(formattedParams)) {
    const type2 = await getBookAppointmentType(apolloClient, formattedParams.typeId, locale);
    promises = [
      type2 ? generateVirtualAppointmentStoreByIdData(formattedParams.virtualStoreCode, type2) : null,
      // TODO: MACC-19077 formattedParams.virtualStoreCode is always a string. Remove as string before merging to master.
      type2,
      void 0
    ];
  } else if (hasInvalidVirtualAppointmentParams(formattedParams)) {
    throw InvalidVirtualAppointmentError();
  } else {
    promises = [
      getBookAppointmentStore(
        apolloClient,
        formattedParams.globalStoreId,
        locale,
        formattedParams.tryInStoreFlow,
        formattedParams.groupId
      ),
      getBookAppointmentType(apolloClient, formattedParams.typeId, locale),
      formattedParams.tryInStoreProductSkus ? getBookAppointmentTryInStoreProducts(
        apolloClient,
        formattedParams.tryInStoreProductSkus,
        locale
      ) : void 0
    ];
  }
  const [store, type, tryInStoreProducts] = await Promise.all(promises);
  if (!store) {
    throw StoreNotFoundError();
  } else if (!type) {
    throw TypeNotFoundError();
  } else if (type && !isAppointmentTypeValid({
    typeId: type?.id,
    store
  })) {
    throw TypeNotAvailableForStoreError();
  }
  return Promise.resolve({
    store,
    type,
    timeSlot: { from: formattedParams.start, until: formattedParams.end },
    tryInStoreProducts
  });
};
export {
  ConfirmationRoot as default
};
//# sourceMappingURL=ConfirmationRoot.js.map
